import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'

export default function isFromGoogleProductListAdLocationUtil (queryParams) {
  queryParams = queryParams || getQueryParamsFromStringObjectUtil()
  return queryParams?.utm_medium === 'product_sync'
}
